import React from 'react'
import cx from 'classnames'
import { AvatarRound, Icon, l } from '@manychat/manyui'

import { useAppSelector } from 'reduxTyped'
import { getInstagramChannel } from 'common/core/selectors/channelSelectors'

import ava1 from './assets/ava1.png'
import ava2 from './assets/ava2.png'

import cm from './styles.module.css'

const COMMENTS = [
  {
    username: 'Mark',
    avatar: ava1,
    isReply: false,
    time: '2h',
    text: l.makeTranslate('Love this picture!'),
    likes: 323,
  },
  {
    isReply: true,
    time: '2h',
    text: l.makeTranslate('That means a lot! So glad it spoke to you 💛'),
    likes: 0,
  },
  {
    username: 'The Star',
    avatar: ava2,
    isReply: false,
    time: '4h',
    text: l.makeTranslate('Amazing! Inspiring photo!'),
    likes: 4,
  },
  {
    isReply: true,
    time: '4h',
    text: l.makeTranslate('Your feedback truly inspires us to keep creating!'),
    likes: 0,
  },
]

export const Showcase = () => {
  const { avatar, username } = useAppSelector(getInstagramChannel)

  return (
    <>
      <h3 className="m-b">{l.translate('How AI comments might look')}</h3>
      <div className={cm.showcase__content}>
        <div className={cm.showcase__post}>
          <ul className={cm.showcase__commentsBlock}>
            {COMMENTS.map((comment, index) => (
              <li className={cx(cm.comment, comment.isReply && cm.comment__reply)} key={index}>
                <AvatarRound src={comment.isReply ? avatar : comment.avatar} size="xsmall" />
                <div>
                  <p className={cm.comment__topline}>
                    <span className={cm.comment__username}>
                      {comment.isReply ? username : comment.username}
                    </span>
                    <span className={cm.comment__time}>{comment.time}</span>
                  </p>
                  <p className={cm.comment__text}>{l.getString(comment.text)}</p>
                </div>
                <div className={cx(cm.comment__likes, !comment.likes && cm.comment__noLikes)}>
                  <Icon.Health size={13} color="white" />
                  {comment.likes > 0 && <p className={cm.comment__likesCounter}>{comment.likes}</p>}
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </>
  )
}
